import Debug from 'debug';
import { QuizPlayerStateMachineAbstractState,
         QuizPlayerStateMachineCommonEvents } from './quiz-player-state-machine-state'
import { QuizPlayerStateMachineData, FoundSession } from '../data';
import { QuizSessionQuery } from '@/app/quiz-session/store';
import { QuizSessionService } from '@/app/quiz-session/service';

const debug = Debug('quiz-player-continue-state')

interface Events extends QuizPlayerStateMachineCommonEvents {
  onContinue: (session: FoundSession) => void
  onIntro: () => void  
}

export class QuizPlayerContinueState extends QuizPlayerStateMachineAbstractState<Events> {

  public readonly name = 'continue'

  stateEvents: Events

  constructor(
    private session: FoundSession,
    private data: QuizPlayerStateMachineData,
    private quizSessionQuery: QuizSessionQuery,
    private quizSessionService: QuizSessionService) {

    super()
  }

  enter() {
    debug('enter')
    if (this.session.type === '') { throw new Error('Coding error: empty session type') }
    this.data.goToContinueSession(this.session.type)
  }

  exit() {
    debug('exit')
  }

  cancel() {
    debug('cancel')
    this.beginCancel()
    this.endCancel()
  }

  continueFoundSession() {
    const session = this.checkSession()
    if (session === false) {
      this.goToIntro()
      return
    }
    
    debug('continueFoundSession', session)
    this.triggerEvent(events => events.onContinue(session))
  }

  abortFoundSession() {
    const session = this.checkSession()
    if (session !== false) {
      this.quizSessionService.abortSession(session.id)
    }

    this.data.abortFoundSession()
    this.goToIntro()
  }

  private goToIntro() {
    this.triggerEvent(events => events.onIntro())
  }

  private checkSession() {
    if (this.session.type === '') { throw new Error('Coding error: empty session type') }
    const found = this.quizSessionQuery.findSession(this.session.id)
    if (!(found && found.phase === 'active')) {
      return false
    }

    return { id: found.id, type: found.type, state: found.state }
  }
}
